import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'site-modules/shared/constants/images';

import { EditorialEntities } from 'client/data/models/editorial';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { isParsableDate } from 'site-modules/shared/utils/date-utils';

import { LoadingSpinner } from 'site-modules/shared/components/loading-spinner/loading-spinner';
import { Link } from 'site-modules/shared/components/link/link';
import { Image } from 'site-modules/shared/components/image/image';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import { VideoPreview } from 'site-modules/shared/components/video-preview/video-preview';

const DEFAULT_IMAGE = getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN);

export function AuthorArticleCard({ article, openVideoModal = noop }) {
  const {
    title = '',
    image = '',
    relativeUrl = '',
    videoId = '',
    summary = '',
    publishDate = '',
    updateDate = '',
    isLoading,
  } = article;

  const date = updateDate || publishDate;
  const cardUrl = videoId ? `https://www.youtube.com/watch?v=${videoId}` : relativeUrl;

  return (
    <li className="author-article-card mb-2 pos-r">
      <LoadingSpinner isLoading={isLoading}>
        <Row>
          <Col xs={12} md={5}>
            <AspectRatioContainer aspectRatio="272:153" className="video-card-img rounded-16 mb-1">
              {videoId ? (
                <VideoPreview
                  videoId={videoId}
                  openVideoModal={openVideoModal}
                  videoTitle={title}
                  creativeId="other_about_us_author_index"
                  isStaticPos
                  isAutoHeight
                  isWhiteBtn
                />
              ) : (
                <Image imageId={image} source={''} alt="" errorImage={DEFAULT_IMAGE} className="w-100" />
              )}
            </AspectRatioContainer>
          </Col>
          <Col xs={12} md={7}>
            {date && isParsableDate(date) && (
              <div className="small text-black mb-0_5">{dateFormat(date, 'mm/dd/yyyy')}</div>
            )}
            <Link to={cardUrl} className={classnames('size-16 fw-bold text-black mb-1', { 'article-link': !videoId })}>
              <ContentFragment componentToUse="span">{title}</ContentFragment>
            </Link>
            <ContentFragment className="medium cool-gray-30">{summary}</ContentFragment>
          </Col>
        </Row>
      </LoadingSpinner>
    </li>
  );
}

AuthorArticleCard.propTypes = {
  article: EditorialEntities.Article.isRequired,
  openVideoModal: PropTypes.func,
};
